import { data, find, findAll } from './dom';
import { readStored, writeStored } from './storage';
import type { ThemeDetail } from './theme-detail';

const headerKey = 'printarnica-zag';

// Katalog tema: filteri po branši, prekidač „Sa zaglavljem firme“ (pamti se između poseta) i otvaranje detalja teme, i
// iz adrese (/#kamioni).
export function enhanceCatalog(detail: ThemeDetail): void {
  const catalog = find(document, 'catalog', HTMLElement);
  const filters = find(document, 'filters', HTMLElement);
  const allThemes = find(filters, 'filter-all', HTMLButtonElement);
  const chips = [allThemes, ...findAll(filters, 'filter', HTMLButtonElement)];
  const headerSwitch = find(filters, 'header-switch', HTMLButtonElement);
  const title = find(catalog, 'catalog-title', HTMLElement);
  const note = find(catalog, 'header-note', HTMLElement);
  const noteOff = find(note, 'header-note-off', HTMLElement);
  const noteOn = find(note, 'header-note-on', HTMLElement);
  const grid = find(catalog, 'theme-grid', HTMLElement);
  const intros = findAll(grid, 'group-intro', HTMLElement);
  const cards = findAll(grid, 'theme-card', HTMLElement);
  const customCard = find(grid, 'custom-card', HTMLElement);
  const openers = findAll(grid, 'theme-open', HTMLButtonElement);

  const isHeaderOn = (): boolean => headerSwitch.getAttribute('aria-checked') === 'true';

  const setHeader = (on: boolean): void => {
    headerSwitch.setAttribute('aria-checked', String(on));
    grid.classList.toggle('theme-grid--with-header', on);
    noteOff.hidden = on;
    noteOn.hidden = !on;
    writeStored(headerKey, on ? '1' : '0');
  };

  const select = (chip: HTMLButtonElement): void => {
    const group = data(chip, 'group');
    chips.forEach(other => other.setAttribute('aria-pressed', String(other === chip)));
    cards.forEach(card => {
      card.hidden = group !== '' && data(card, 'group') !== group;
    });
    intros.forEach(intro => {
      intro.hidden = data(intro, 'group') !== group;
    });
    customCard.hidden = group !== '';
    title.textContent = data(chip, 'title');
  };

  chips.forEach(chip => $(chip).on('click', () => select(chip)));
  $(headerSwitch).on('click', () => setHeader(!isHeaderOn()));
  openers.forEach(opener => {
    opener.hidden = false;
    $(opener).on('click', () => detail.open(opener, isHeaderOn()));
  });

  filters.hidden = false;
  note.hidden = false;
  setHeader(readStored(headerKey) === '1');

  const requested = openers.find(opener => data(opener, 'theme') === window.location.hash.slice(1));
  if (requested) detail.open(requested, isHeaderOn());
}
